import _objectSpread from "D:/svnworkspace/GZEB/webWorks/e-boat-web/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.filter.js";
import "core-js/modules/esnext.iterator.map.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import { ref, watch } from 'vue';
import { ElTree } from 'element-plus';
import 'element-plus/es/components/tree/style/css'

import global from '@/component-create/utils/global';
import { GLOBAL_DATA } from '@/component-create/utils/global-enum';
import { log } from '@/component-create/utils/log';
import { Search } from '@icon-park/vue-next';
export default /*@__PURE__*/_defineComponent({
  __name: 'XSearchTree',
  props: {
    url: String,
    params: Object,
    data: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    label: {
      type: [String, Function],
      default: 'label'
    },
    value: {
      type: [String, Function],
      default: 'value'
    },
    format: Function,
    elTreeProp: Object
  },
  emits: ['check-change', 'current-change', 'node-click', 'node-contextmenu', 'node-collapse', 'node-expand', 'check', 'node-drag-start', 'node-drag-end', 'node-drop', 'node-drag-leave', 'node-drag-enter', 'node-drag-over'],
  setup: function setup(__props, _ref) {
    var __emit = _ref.emit;
    var emits = __emit;
    var prop = __props;
    var TREE_REQUEST = global.globalVal[GLOBAL_DATA.TREE_REQUEST];
    var treeData = ref([]);
    var filterText = ref('');
    var treeRef = ref();
    if (prop.url) {
      load();
    }
    watch(filterText, function (val) {
      treeRef.value.filter(val);
    });
    /**
     * 过滤
     * @param value 搜索值
     * @param data 树节点数据
     */
    var filterNode = function filterNode(value, data) {
      if (!value) return true;
      return data.label.includes(value);
    };
    /**
     * 加载
     * @param params 请求参数
     */
    function load() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var param = _objectSpread(_objectSpread({}, prop.params), params);
      if (TREE_REQUEST) {
        TREE_REQUEST(prop.url, param).then(function (res) {
          treeData.value = prop.format ? prop.format(res.data) : autoFormat(res.data);
        });
      } else {
        log('XSearchTree', '加载失败，未配置搜索树加载请求接口：' + GLOBAL_DATA.TREE_REQUEST, 'error');
      }
    }
    /**
     * 自动格式化
     * @param data 待格式化数据
     */
    function autoFormat(data) {
      if (!data) {
        return [];
      }
      var newData = data.map(function (item) {
        return _objectSpread(_objectSpread({}, item), {}, {
          label: typeof prop.label === 'string' ? item[prop.label] : prop.label(item),
          value: typeof prop.value === 'string' ? item[prop.value] : prop.value(item),
          children: autoFormat(item.children)
        });
      });
      return newData;
    }
    function elTreeEventEmit(event) {
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }
      emits.apply(void 0, [event].concat(args));
    }
    return function (_ctx, _cache) {
      var _component_el_input = _resolveComponent("el-input");
      return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_el_input, {
        class: "search",
        modelValue: filterText.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
          return filterText.value = $event;
        }),
        placeholder: "请输入搜索关键字",
        "prefix-icon": _unref(Search)
      }, null, 8, ["modelValue", "prefix-icon"]), _createVNode(_unref(ElTree), _mergeProps({
        ref_key: "treeRef",
        ref: treeRef,
        class: "filter-tree",
        data: treeData.value,
        "default-expand-all": "",
        "filter-node-method": filterNode,
        "empty-text": "暂无数据"
      }, __props.elTreeProp, {
        onNodeClick: _cache[1] || (_cache[1] = function () {
          for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
            args[_key2] = arguments[_key2];
          }
          return elTreeEventEmit.apply(void 0, ['node-click'].concat(args));
        }),
        onNodeContextmenu: _cache[2] || (_cache[2] = function () {
          for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
            args[_key3] = arguments[_key3];
          }
          return elTreeEventEmit.apply(void 0, ['node-contextmenu'].concat(args));
        }),
        onCheckChange: _cache[3] || (_cache[3] = function () {
          for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
            args[_key4] = arguments[_key4];
          }
          return elTreeEventEmit.apply(void 0, ['check-change'].concat(args));
        }),
        onCheck: _cache[4] || (_cache[4] = function () {
          for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
            args[_key5] = arguments[_key5];
          }
          return elTreeEventEmit.apply(void 0, ['check'].concat(args));
        }),
        onCurrentChange: _cache[5] || (_cache[5] = function () {
          for (var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
            args[_key6] = arguments[_key6];
          }
          return elTreeEventEmit.apply(void 0, ['current-change'].concat(args));
        }),
        onNodeExpand: _cache[6] || (_cache[6] = function () {
          for (var _len7 = arguments.length, args = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
            args[_key7] = arguments[_key7];
          }
          return elTreeEventEmit.apply(void 0, ['node-expand'].concat(args));
        }),
        onNodeCollapse: _cache[7] || (_cache[7] = function () {
          for (var _len8 = arguments.length, args = new Array(_len8), _key8 = 0; _key8 < _len8; _key8++) {
            args[_key8] = arguments[_key8];
          }
          return elTreeEventEmit.apply(void 0, ['node-collapse'].concat(args));
        }),
        onNodeDragStart: _cache[8] || (_cache[8] = function () {
          for (var _len9 = arguments.length, args = new Array(_len9), _key9 = 0; _key9 < _len9; _key9++) {
            args[_key9] = arguments[_key9];
          }
          return elTreeEventEmit.apply(void 0, ['node-drag-start'].concat(args));
        }),
        onNodeDragEnter: _cache[9] || (_cache[9] = function () {
          for (var _len10 = arguments.length, args = new Array(_len10), _key10 = 0; _key10 < _len10; _key10++) {
            args[_key10] = arguments[_key10];
          }
          return elTreeEventEmit.apply(void 0, ['node-drag-enter'].concat(args));
        }),
        onNodeDragLeave: _cache[10] || (_cache[10] = function () {
          for (var _len11 = arguments.length, args = new Array(_len11), _key11 = 0; _key11 < _len11; _key11++) {
            args[_key11] = arguments[_key11];
          }
          return elTreeEventEmit.apply(void 0, ['node-drag-leave'].concat(args));
        }),
        onNodeDragOver: _cache[11] || (_cache[11] = function () {
          for (var _len12 = arguments.length, args = new Array(_len12), _key12 = 0; _key12 < _len12; _key12++) {
            args[_key12] = arguments[_key12];
          }
          return elTreeEventEmit.apply(void 0, ['node-drag-over'].concat(args));
        }),
        onNodeDragEnd: _cache[12] || (_cache[12] = function () {
          for (var _len13 = arguments.length, args = new Array(_len13), _key13 = 0; _key13 < _len13; _key13++) {
            args[_key13] = arguments[_key13];
          }
          return elTreeEventEmit.apply(void 0, ['node-drag-end'].concat(args));
        }),
        onNodeDrop: _cache[13] || (_cache[13] = function () {
          for (var _len14 = arguments.length, args = new Array(_len14), _key14 = 0; _key14 < _len14; _key14++) {
            args[_key14] = arguments[_key14];
          }
          return elTreeEventEmit.apply(void 0, ['node-drop'].concat(args));
        })
      }), null, 16, ["data"])]);
    };
  }
});